import { useCallback, useEffect, useRef } from "react";
import classNames from "classnames";
import { EMPTY_OBJECT, EMPTY_STRING, ZERO } from "../../../constants";

const AUTH_CODE = "authCode";
const BACKSPACE = "Backspace";
const NUMBER_REGEX = /[^0-9]/gi;
const FIVE = 5;
const TEXT = "text";
const PASTE = "paste";
const EMPTY_ARRAY = [];

const OtpInput = ({ values, setFieldValue, isOtpValid, setIsOtpValid }) => {
  const inputRef = useRef(EMPTY_ARRAY);
  const handleOnChange = (event, key, index) => {
    setIsOtpValid(true);
    const { value } = event.target;
    value.replace(NUMBER_REGEX, EMPTY_STRING);
    if (!NUMBER_REGEX.test(value)) {
      const changedValue = {
        ...values.authCode,
        [key]: value.slice(-1),
      };
      setFieldValue(AUTH_CODE, changedValue);
      if (value && index < FIVE) inputRef.current[index + 1].focus();
    }
  };

  const handleBackSpace = (event, key, index) => {
    setIsOtpValid(true);
    if (event.key === BACKSPACE && !event.target.value && index > ZERO) {
      const changedValue = { ...values.authCode, [key]: EMPTY_STRING };
      setFieldValue(AUTH_CODE, changedValue);
      inputRef.current[index - 1].focus();
    }
  };

  const pasteTextHandler = useCallback(
    (event) => {
      event.preventDefault();
      const pastedText = event.clipboardData.getData(TEXT);
      const modifiedPastedText = pastedText.replace(NUMBER_REGEX, EMPTY_STRING);

      const fieldValues = EMPTY_OBJECT;
      Object.keys(values.authCode).forEach((key, index) => {
        fieldValues[key] = modifiedPastedText[index] || EMPTY_STRING;
      });

      setFieldValue(AUTH_CODE, fieldValues);
      inputRef.current[FIVE]?.focus();
    },
    [setFieldValue, values]
  );

  useEffect(() => {
    const currentInputRefs = inputRef.current;
    currentInputRefs.forEach((input) =>
      input?.addEventListener(PASTE, pasteTextHandler)
    );
    return () => {
      currentInputRefs.forEach((input) =>
        input?.removeEventListener(PASTE, pasteTextHandler)
      );
    };
  }, [pasteTextHandler]);

  return Object.keys(values.authCode).map((key, index) => (
    <input
      key={key}
      ref={(element) => (inputRef.current[index] = element)}
      type={TEXT}
      name={key}
      value={values.authCode[key]}
      className={classNames(
        "text-center text-l w-11 h-11 text-white rounded-md bg-black",
        {
          "border bg-black focus:border-2": isOtpValid,
          " border-2 border-solid border-red-500 outline-red-500 shadow-none":
            !isOtpValid,
        }
      )}
      onChange={(event) => handleOnChange(event, key, index)}
      onKeyUp={(event) => handleBackSpace(event, key, index)}
    />
  ));
};

export default OtpInput;
